import React from "react";
import { Linkedin, ArrowRight } from "lucide-react";
import PageHero from "../components/PageHero";
import { useLanguage } from "../i18n/LanguageContext";

const Insights = () => {
  const { t } = useLanguage();
  const i18n = t.insights;
  return (
    <div data-testid="insights-page">
      <PageHero eyebrow={i18n.eyebrow} title={i18n.title} intro={i18n.intro} testid="insights-hero" />

      <section className="border-b border-synergia-line">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 md:py-20 flex flex-wrap items-center justify-between gap-6">
          <div className="eyebrow">LinkedIn</div>
          <a
            href="https://www.linkedin.com"
            target="_blank"
            rel="noreferrer noopener"
            className="inline-flex items-center gap-3 font-montserrat font-semibold text-synergia-green link-underline"
            data-testid="insights-linkedin"
          >
            <Linkedin size={18} /> {i18n.linkedinLabel} <ArrowRight size={16} />
          </a>
        </div>
      </section>

      <section className="border-b border-synergia-line">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-24 md:py-32">
          <div className="border-t border-synergia-line">
            {i18n.articles.map((a, idx) => (
              <article
                key={a.title}
                className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-16 py-12 border-b border-synergia-line"
                data-testid={`insight-article-${idx}`}
              >
                <div className="md:col-span-3">
                  <div className="font-inter text-xs tracking-widest text-synergia-graphite/60">
                    {a.date}
                  </div>
                  <div className="eyebrow mt-3">{a.category}</div>
                </div>
                <div className="md:col-span-9">
                  <h2 className="font-montserrat font-semibold text-2xl md:text-3xl leading-snug tracking-tight text-synergia-graphite text-balance">
                    {a.title}
                  </h2>
                  <p className="mt-6 font-inter text-base leading-relaxed text-synergia-graphite/75 max-w-3xl">
                    {a.excerpt}
                  </p>
                  <a
                    href="https://www.linkedin.com"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="mt-8 inline-flex items-center gap-2 text-synergia-green font-montserrat font-semibold link-underline"
                    data-testid={`insight-read-more-${idx}`}
                  >
                    {i18n.readMore} <ArrowRight size={16} />
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Insights;
